import Api from "../../services/Api";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import useAuth from "../../routes/login/AuthContext";
import { HousingMajors } from "../HousingMajors";

export const HousingOptions = () => {
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getAuthToken } = useAuth();

  async function handleModify(l2Id: any, oldValue: any, newValue: any, rowId: any) {
    return await Api.requestNewOrEditExistingHousingMajorEntry(
      selectedNetworkId,
      l2Id,
      rowId,
      newValue,
      "housing",
      await getAuthToken()
    );
  }

  async function loadHousingOptions(l2Id: any) {
    return Api.getHousingOptions(selectedNetworkId, l2Id, await getAuthToken()).then(
      (x: { active: any; housing: any }) => ({
        active: x.active,
        entries: x.active && x.housing ? x.housing : [],
      })
    );
  }

  async function requestActivationChange(l2Id: any, status: any) {
    return Api.requestActivationChangeHousingMajorEntry(
      selectedNetworkId,
      l2Id,
      status,
      "housing",
      await getAuthToken()
    );
  }

  return (
      <HousingMajors
        objectType="Housing"
        handleObjectChange={handleModify}
        handleActivationChange={requestActivationChange}
        loadData={loadHousingOptions}
      />
  );
};
